import type { IconCode } from "@components/Atoms/Icon/LucideIcon";
import DiagramType from "@core/components/Diagram/DiagramType";
import ModalToOpen from "@core-ui/ContextServices/ModalToOpenService/model/ModalsToOpen";
import type { LastUsedDiagramType } from "@core-ui/stores/EditorStore";
import t from "@ext/localization/locale/translate";
import { startBpmn } from "../diagrams/bpmn/bpmnData";
import { startMermaid } from "../diagrams/mermaid/mermaidData";
import { startPlantUmlText } from "../diagrams/plantUml/plantUmlData";

export interface DiagramDescriptor {
	extension: string;
	template: string;
	icon: IconCode;
	label: () => string;
	lastUsed: LastUsedDiagramType;
	editorModal: ModalToOpen;
	/** Исходник можно держать код-блоком в статье. Для BPMN нельзя: файл должен открываться в Camunda. */
	inlineFence: boolean;
}

const DIAGRAM_DESCRIPTORS: Record<DiagramType, DiagramDescriptor> = {
	[DiagramType.mermaid]: {
		extension: "mermaid",
		template: startMermaid,
		icon: "mermaid",
		label: () => t("diagram.names.mermaid"),
		lastUsed: "mermaid",
		editorModal: ModalToOpen.DiagramEditor,
		inlineFence: true,
	},
	[DiagramType["plant-uml"]]: {
		extension: "puml",
		template: startPlantUmlText,
		icon: "plant-uml",
		label: () => t("diagram.names.puml"),
		lastUsed: "plant-uml",
		editorModal: ModalToOpen.DiagramEditor,
		inlineFence: true,
	},
	[DiagramType.bpmn]: {
		extension: "bpmn",
		template: startBpmn,
		icon: "bpmn",
		label: () => t("diagram.names.bpmn"),
		lastUsed: "bpmn",
		editorModal: ModalToOpen.BpmnEditor,
		inlineFence: false,
	},
};

export const getDiagramDescriptor = (diagramName: DiagramType): DiagramDescriptor => DIAGRAM_DESCRIPTORS[diagramName];

export const getDiagramTypeByExtension = (extension: string | null): DiagramType | null => {
	if (!extension) return null;
	const normalized = extension.replace(/^\./, "").toLowerCase();
	const found = Object.entries(DIAGRAM_DESCRIPTORS).find(([, descriptor]) => descriptor.extension === normalized);
	return found ? (found[0] as DiagramType) : null;
};

export default DIAGRAM_DESCRIPTORS;
